import React from "react";
import { Link } from "react-router-dom";
import { withTranslation, type WithTranslation } from "react-i18next";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps extends WithTranslation {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, t }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className="Breadcrumbs" aria-label={t("common.label_breadcrumbs")}>
      <ol className="Breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const key = `${item.label}-${index}`;

          return (
            <li key={key} className="Breadcrumbs-item">
              {item.to && !isLast ? (
                <Link className="Breadcrumbs-link" to={item.to}>
                  {item.label}
                </Link>
              ) : (
                <span className="Breadcrumbs-current" aria-current="page">
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default withTranslation()(Breadcrumbs);
